import { render, staticRenderFns } from "./vacaView.vue?vue&type=template&id=72c134a1&scoped=true"
import script from "./vacaView.vue?vue&type=script&lang=js"
export * from "./vacaView.vue?vue&type=script&lang=js"
import style0 from "./vacaView.vue?vue&type=style&index=0&id=72c134a1&prod&lang=scss&scoped=true"
import style1 from "./vacaView.vue?vue&type=style&index=1&id=72c134a1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c134a1",
  null
  
)

export default component.exports